import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Camera } from "lucide-react";

/**
 * TeamGallery — editorial masonry of real trip photos.
 * Fetches /api/gallery. Renders nothing if empty (fails gracefully).
 */
export default function TeamGallery({ title = "Nossa Fadinha em campo", subtitle }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section className="container-orion py-16" data-testid="team-gallery">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] text-orion-gold font-semibold">
        <Camera size={14} /> Galeria · Momentos Orion
      </div>
      <h2 className="mt-2 font-serif text-xl md:text-4xl text-orion-purple leading-tight">
        {title}
      </h2>
      {subtitle && <p className="mt-2 text-sm md:text-base text-[#594A63] max-w-2xl">{subtitle}</p>}

      <div className="mt-8 md:mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {items.slice(0, 8).map((g) => (
          <figure
            key={g.slug}
            className="group relative overflow-hidden rounded-xl bg-[#EFEAE0] aspect-[3/4]"
            data-testid={`gallery-item-${g.slug}`}
          >
            <img
              src={g.url}
              alt={g.title}
              loading="lazy"
              decoding="async"
              width="600"
              height="800"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-3 md:p-4 text-white">
              <div className="text-[10px] uppercase tracking-[0.28em] text-orion-gold">{g.credit || "Viagens Orion"}</div>
              <div className="font-serif text-sm md:text-lg leading-tight">{g.title}</div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
